import { history } from "./../../index";
import { observable, computed, action, runInAction } from "mobx";
import service from "../services";
import Language from "../../shared/enums/languageEnum";
import Role from "../../shared/enums/roleEnum";

export default class UserStore {
  rootStore;

  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  @observable user = null;
  @observable loading = false;
  @observable loadingInitial = false;
  @observable loadingSave = false;
  @observable generalLoading = false;
  // @observable userRegistry = new Map();
  @observable userList = [];

  @computed get isLoggedIn() {
    return !!this.user;
  }

  @computed get getRole() {
    return this.user && this.user.role;
  }

  @action login = async (values) => {
    this.loading = true;

    try {
      const user = await service.User.login(values);

      runInAction(() => {
        this.user = user;
        this.loading = false;
      });
      this.rootStore.commonStore.setToken(user.authorizationToken);

      if (this.user.role === Role.ADMIN)
        history.push("/administration");
      else if (this.user.role === Role.SUPER_ADMIN)
        history.push("/companies");
      else
        history.push("/home");
    } catch (error) {
      runInAction(() => {
        this.loading = false;
        throw error;
      });
    }
  };

  @action logout = () => {
    this.rootStore.commonStore.setToken(null);
    this.user = null;
    history.push("/login");
  };

  @action getUser = async () => {
    try {
      const user = await service.User.current();
      runInAction(() => {
        this.user = user;

        return user;
      });
    } catch (error) {
      console.log(error);
    }
  };

  @action loadUsers = async () => {
    this.loadingInitial = true;

    try {
      const users = await service.User.getAll();
      runInAction("loading users ", () => {
        this.userList = users;
        // users.forEach((user) => {
        //   this.userRegistry.set(user.id, user);
        // });
        this.loadingInitial = false;
      });
    } catch (error) {
      runInAction("loading users error", () => {
        this.loadingInitial = false;
      });
    }
  };

  @action loadUser = async (userId) => {
    this.loadingSave = true;

    try {
      let user = await service.User.getUser(userId);
      return runInAction("get user", async () => {
        this.loadingSave = false;

        return user;
      });
    } catch (error) {
      return runInAction("get user error", () => {
        this.loadingSave = false;

        return null;
      });
    }
  };

  @action save = async (user) => {
    this.loadingSave = true;

    try {
      await service.User.save(user);
      return runInAction("save user", async () => {
        this.loadingSave = false;

        return { success: true };
      });
    } catch (error) {
      return runInAction("save user error", () => {
        this.loadingSave = false;

        return { success: false };
      });
    }
  };

  @action edit = async (userId, user) => {
    this.loadingSave = true;

    try {
      await service.User.edit(userId, user);
      return runInAction("edit save user", async () => {
        this.loadingSave = false;

        return { success: true };
      });
    } catch (error) {
      return runInAction("edit save user error", () => {
        this.loadingSave = false;

        return { success: false };
      });
    }
  };

  @action getToken = async (userId) => {
    this.generalLoading = true;

    try {
      let token = await service.User.getToken(userId);
      return runInAction("get token user", async () => {
        this.generalLoading = false;

        return token;
      });
    } catch (error) {
      return runInAction("get token user error", () => {
        this.generalLoading = false;

        return null;
      });
    }
  };

  @action sendForgotPassword = async(username) => {
    try {
      await service.User.sendForgotPassword(username);
      return runInAction("get token user", async () => {
        return true;
      });
    } catch (error) {
      return runInAction("get token user error", () => {
        return false;
      });
    }
  };

  @action resetPassword = async(resetPasswordData) => {
    try {
      await service.User.resetPassword(resetPasswordData);
      return runInAction("reset password user", async () => {
        return true;
      });
    } catch (error) {
      return runInAction("reset password user error", () => {
        return false;
      });
    }
  };

  @action removeUser = async(user) => {
    try {
      await service.User.removeUser(user.id);
      return runInAction("remove user", async () => {
        return true;
      });
    } catch (error) {
      return runInAction("remove user error", () => {
        return false;
      });
    }
  };

  @action newUser = () => {
      return {
          name: "",
          surname: "",
          username: "",
          password: "",
          mail: "",
          language: Language.FRENCH,
          code: "",
          role: Role.ADMIN,
          authorizationToken: "",
          companyName: "",
          crifUserName: "",
          crifPassword: "",
          crifUserNameForTesting: "",
          crifPasswordForTesting: "",
          showPasswordTemp: false
      }
  };

  @action newRecoveryPasswordData = (guid) => {
    return {
      username: "",
      password: "",
      repeatPassword: "",
      recoveryGuid: guid
    }
  };
}